// src/pages/Admin/StatistiquesComptabilite/components/ComptaMobileSection.jsx

import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function ComptaMobileSection({
  id,
  eyebrow,
  title,
  description,
  icon: Icon,
  isOpen,
  onToggle,
  children,
}) {
  return (
    <section
      id={id}
      className="scroll-mt-24 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900"
    >
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left transition active:scale-[0.99] dark:hover:bg-slate-800/60 sm:px-5"
      >
        <div className="flex min-w-0 gap-3">
          {Icon ? (
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
              <Icon />
            </span>
          ) : null}

          <div className="min-w-0">
            {eyebrow ? (
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                {eyebrow}
              </p>
            ) : null}

            <h2 className="mt-1 text-lg font-bold leading-snug text-slate-900 dark:text-white sm:text-xl">
              {title}
            </h2>

            {description ? (
              <p className="mt-2 line-clamp-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
                {description}
              </p>
            ) : null}
          </div>
        </div>

        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200">
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </button>

      {isOpen ? (
        <div className="border-t border-slate-200 px-3 py-4 dark:border-slate-800 sm:px-5">
          <div className="min-w-0 overflow-hidden">{children}</div>
        </div>
      ) : null}
    </section>
  );
}